/**
 * Auth Store for Payment Service Frontend
 * Uses shared auth store with payment-service specific configuration
 */

import { createAuthStore } from '@plutos/shared/frontend';

// Get API URL from environment
const API_BASE_URL = import.meta.env.VITE_API_URL || '';

// Create auth store with payment-service config
export const useAuthStore = createAuthStore({
  apiBaseUrl: API_BASE_URL,
  onAuthChange: (user) => {
    console.log('[AuthStore] Auth state changed:', user ? user.email : 'logged out');
  },
});

// Re-export types for convenience
export type { 
  AuthUser, 
  LoginCredentials, 
  RegisterCredentials, 
  LoginResponse, 
  RegisterResponse, 
  OAuthProvider,
  OAuthTokensResponse,
  LegalAcceptanceData,
} from '@plutos/shared/frontend';
